import Vue from 'vue';
import VueMq from 'vue-mq';
import { sync } from 'vuex-router-sync';

import { NavPlugin, NavbarPlugin, BModal, BTooltip, BLink } from 'bootstrap-vue';

import App from './App.vue';
import createStore from './store';
import createRouter from './router';
import customMixin from './mixins';
import breakpoints from './util/breakpoints';

/**
 * Expose a factory function that creates a fresh set of store, router,
 * app instances on each call (which is called for each SSR request)
 */
export default function createApp() {
   const router = createRouter();
   const store = createStore();
   /**
    * sync the router with the vuex store.
    * this registers `store.state.route`
    */
   sync(store, router); // disabling it for now as we are not using route as state

   Vue.use(NavPlugin);
   Vue.use(NavbarPlugin);
   Vue.component('b-modal', BModal);
   Vue.component('b-tooltip', BTooltip);
   Vue.component('b-link', BLink);

   Vue.use(VueMq, {
      breakpoints,
      defaultBreakpoint: 'sm',
   });

   Vue.mixin(customMixin);

   // changes element style properties
   Vue.directive('transform', {
      bind(el, binding, vnode) {
         binding.value && (el.style.transform = binding.value);
      },
   });

   /**
    * create the app instance.
    * here we inject the router, store and ssr context to all child components,
    * making them available everywhere as `this.$router` and `this.$store`.
    */
   const app = new Vue({
      router,
      store,
      render: h => h(App),
   });

   return {
      app,
      router,
      store,
   };
}
